import { createSelector } from '@ngrx/store';

import * as fromRepFeature from '../reducers';
import * as fromRepSchoolSearch from '../reducers/reports-school-search.reducer';

export const getRepSchoolSearchState = createSelector(
  fromRepFeature.getReportsSearchState,
  (state: fromRepFeature.ReportsSearchState) => state.schoolSearch
);
export const getRepSchoolSearchCriteriaState = createSelector(
    getRepSchoolSearchState,
  fromRepSchoolSearch.getSchoolSearchCriteria
);
